import {
  ApInvoiceTransactionStatusEnum,
  useDeleteTransactionItem,
} from '@/context/services/transaction_items/List/TransactionItems.service';
import { useErrorTrackingSystem } from '@/hooks/useErrorTrackingSystem';
import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

type Props = {
  transaction_item_id: string;
  handlerSuccess: () => void;
  showLoading: (loading: boolean) => void;
};

export const useSubmitDeleteTransactionItem = ({
  transaction_item_id,
  handlerSuccess,
  showLoading,
}: Props) => {
  const { report_type_id } = useParams();
  const { mutateAsync } = useDeleteTransactionItem(report_type_id ?? '');
  const { t } = useTranslation();
  const notify = useToastAPI();
  const { send } = useErrorTrackingSystem();

  const onDelete = useCallback(async () => {
    showLoading(true);
    try {
      const resp = await mutateAsync({
        id: transaction_item_id,
      });

      if (resp.status === ApInvoiceTransactionStatusEnum.SUCCESS) {
        notify.success({
          title: t('transaction_items.delete.success'),
          duration: 5,
        });
        handlerSuccess();
        showLoading(false);
      } else if (resp.status === ApInvoiceTransactionStatusEnum.AUTH_ERROR) {
        location.href = resp.redirectPath;
        return;
      } else {
        notify.error({
          title: t('transaction_items.delete.error'),
          duration: 5,
        });
        showLoading(false);
      }
    } catch (error) {
      if (error instanceof Error && error?.name === 'AxiosError') {
        send(error.message);
      } else {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        send(error as Error);
      }
      notify.error({
        title: t('transaction_items.delete.error'),
        duration: 5,
      });
      showLoading(false);
    }
  }, [
    showLoading,
    mutateAsync,
    transaction_item_id,
    notify,
    t,
    handlerSuccess,
    send,
  ]);

  return { onDelete };
};
